import FooterSection from 'assets/Footer';
import Navbar from '../assets/Navbar';
import CardDesign from '../components/cardDesign';
import useAllTrendingProducts from 'hook/useAllTrendingProducts';
import ScreenScrollToTop from "../components/ScreenScrollToTop";
import CardShimmer from "../components/shimmer/CardShimmer";
const TrendingProductsFullPage = () => {
    const { allTrendingProducts, loading1, error } = useAllTrendingProducts();

    if (loading1) {
        return (
            <div className='bg-gray-100 flex flex-col min-h-[100dvh]'>
                <CardShimmer count={8} />
            </div>
        );
    }
    return (
        <div className='bg-gray-100 flex flex-col min-h-[100dvh]'>
            <Navbar />
            <div className="container mx-auto relative">
                {!loading1 && !error && allTrendingProducts.length > 0 && (
                    <div className='mb-3'>
                        <div className="flex items-center justify-center w-full px-4 md:my-5 my-3">
                            <span className="md:text-2xl text-xl md:font-bold font-extrabold text-black tracking-wide pt-3 pb-1">
                                TRENDING PRODUCTS
                            </span>
                        </div>
                        <CardDesign likeData={allTrendingProducts} />
                    </div>
                )}
            </div>
            <FooterSection />
            <ScreenScrollToTop />
        </div>
    );
};

export default TrendingProductsFullPage;